import React from 'react'
import {Redirect, Route} from "react-router-dom";
import PatientLogInPage from "../Roles/Patient/PatinetAuth/PatientLogIn/PatientLogInPage";
import PatientSignInPage from "../Roles/Patient/PatinetAuth/PatinetSignIn/PatientSignInPage.jx";
import {PatientQrResultSwitcher} from "../Roles/General/QrResult/QrResult";
import {PatientQrResultSwitcher2} from "../Roles/General/QrResult2/QrResult2";
import DocOrgAuthPage from "../Roles/General/AuthPage/DocOrgAuthPage";
import PasswordRestore from "../Roles/General/PasswordRestore/PasswordRestoreStep1";
import PasswordRestoreStep2 from "../Roles/General/PasswordRestore/PasswordRestoreStep2";
import RegisterConfirm from "../Roles/Patient/PatinetAuth/RegisterConfirm";
import OrgSearch from "../Roles/General/OrgSearch";

export const GeneralRoutes = () => {
    const {REACT_APP_URL_PREFIX} = process.env

    return (
        <>
            <Route path={'/dashboard'} exact> <Redirect to={REACT_APP_URL_PREFIX + '/logIn'}/> </Route>
            <Route path={REACT_APP_URL_PREFIX + '/login'} component={PatientLogInPage}/>
            <Route path={REACT_APP_URL_PREFIX + '/signIn'} component={PatientSignInPage}/>
            <Route path={REACT_APP_URL_PREFIX + '/checkIn'} component={PatientQrResultSwitcher}/>
            <Route path={REACT_APP_URL_PREFIX + '/checkBlank/:data'} component={PatientQrResultSwitcher2}/>
            <Route path={REACT_APP_URL_PREFIX + '/orgLogin'} component={DocOrgAuthPage}/>
            <Route path={REACT_APP_URL_PREFIX + '/restore/:restoreType'} component={PasswordRestore}/>
            <Route path={REACT_APP_URL_PREFIX + '/password/confirm/:type/:token/:email'} component={PasswordRestoreStep2} exact />
            <Route path={REACT_APP_URL_PREFIX + '/patients/confirm/:sms/:patientId'} exact component={RegisterConfirm}/>
            <Route path={REACT_APP_URL_PREFIX + '/orgSearch'} component={OrgSearch}/>
        </>
    )
}